export type RuntimeEnvironment = "dev" | "test" | "prod" | "local";

export type PublicAppConfig = {
  environment: RuntimeEnvironment;
  showTestBanner: boolean;
  portalApiBaseUrl: string;
  useMockApi: boolean;
  turnstileSiteKey: string;
  markerProjectId: string;
  maintenance: {
    enabled: boolean;
    title: string;
    message: string;
  };
  support: {
    email: string;
    phone: string;
    phoneDigits: string;
  };
  copy: {
    loginSubtitle: string;
  };
  session: {
    idleTimeoutMs: number;
    warningMs: number;
  };
};

const environment = (import.meta.env.VITE_APP_ENV ?? "local") as RuntimeEnvironment;
const testTurnstileSiteKey = "1x00000000000000000000AA";
const maintenanceTitle = import.meta.env.VITE_MAINTENANCE_TITLE ?? "Under Construction";
const maintenanceMessage = import.meta.env.VITE_MAINTENANCE_MESSAGE ??
  "The Companion Pharmacy Prescriber Portal is temporarily unavailable while our team completes updates. Please check back soon.";

export const buildInfo = __CPPP_BUILD_INFO__;

export const appConfig: PublicAppConfig = {
  environment,
  showTestBanner: environment === "test" || environment === "local",
  portalApiBaseUrl: import.meta.env.VITE_PORTAL_API_BASE_URL ?? "",
  useMockApi: import.meta.env.VITE_USE_MOCK_API === "true",
  turnstileSiteKey:
    import.meta.env.VITE_TURNSTILE_SITE_KEY ??
    (environment === "prod" ? "" : testTurnstileSiteKey),
  markerProjectId:
    environment === "test"
      ? import.meta.env.VITE_MARKER_PROJECT_ID ?? "6a217e3c261d97a9b85415cc"
      : "",
  maintenance: {
    enabled: import.meta.env.VITE_MAINTENANCE_MODE === "true",
    title: maintenanceTitle,
    message: maintenanceMessage
  },
  support: {
    email: "support@companionpharmacy.com",
    phone: "(919) 505-8779",
    phoneDigits: "19195058779"
  },
  copy: {
    loginSubtitle: "Sign in to your Prescriber Portal account"
  },
  session: {
    idleTimeoutMs: Number(import.meta.env.VITE_SESSION_IDLE_TIMEOUT_MS ?? 30 * 60 * 1000),
    warningMs: Number(import.meta.env.VITE_SESSION_WARNING_MS ?? 2 * 60 * 1000)
  }
};
